import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { DeletePackageProvider } from "./context/DeletePackageProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <DeletePackageProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </DeletePackageProvider>
);
